<template>
  <div class="button temr">
    <van-button
      type="danger"
      :disabled="disabled"
      @click="click"
      :loading="loading"
      :loadingText="loadingText"
    >{{text}}</van-button>
  </div>
</template>

<script>
export default {
  name: 'Button',
  props: ['disabled', 'loading', 'click', 'text', 'loadingText'],
};
</script>
<style scoped>
.button {
  padding-right: 15px;
  height: 68px;
  background: #fff;
  padding-left: 15px;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  position: fixed;
}
.button >>> .van-button {
  width: 100%;
}
.button >>> .van-button__text {
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #ffffff;
  font-weight: 600;
}
.van-button--disabled {
  color: #fff;
  background-color: #7691a3 !important;
  border: 1px solid #7691a3 !important;
}
.van-button--danger {
  background: #ff6538;
  border-radius: 4px;
  font-size: 17px;
}
.van-button--normal {
  font-size: 17px;
}
.temr::after {
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
  box-sizing: border-box;
  border-bottom: 1px solid #ccc;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
</style>
